import Label from './Label';
import type { LabelProps } from './Label';

export type { LabelProps };
export default Label;
